export default __webpack_public_path__ + "static/media/between_members.d602fd8e.svg";